import type { Theme } from "@mui/material/styles";

/** Styles MUI pour le rendu Markdown (home publique, admin, docs). */
export function getMarkdownContentSx(theme: Theme) {
  return {
    "& h1": {
      fontSize: "1.5rem",
      fontWeight: 700,
      mt: 3,
      mb: 1.5,
      color: "text.primary",
    },
    "& h1:first-of-type": { mt: 0 },
    "& h2, & h3": {
      fontSize: "1.1rem",
      fontWeight: 700,
      mt: 2.5,
      mb: 1,
      color: "text.primary",
    },
    "& p": { mb: 1.5, lineHeight: 1.75 },
    "& ul, & ol": { pl: 2.5, mb: 1.5, "& li": { mb: 0.5, lineHeight: 1.65 } },
    "& hr": { my: 2.5, borderColor: "divider" },
    "& strong": { fontWeight: 700 },
    "& em": { fontStyle: "italic" },
    "& a": {
      color: theme.palette.mode === "dark" ? "secondary.main" : "primary.main",
      fontWeight: 600,
      textDecoration: "underline",
    },
  };
}
